import { Box, Typography } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

interface CzechQrCodeProps {
  swift: string;
  actorName: string;
  iban: string;
  amount: number;
}

function buildSpaydString({
  swift,
  actorName,
  iban,
  amount,
}: CzechQrCodeProps): string {
  // SPAYD (Short Payment Descriptor) — Czech QR Platba standard
  // See: https://qr-platba.cz/pro-vyvojare/specifikace-formatu/
  const parts = [
    "SPD*1.0",
    `ACC:${iban.replace(/\s/g, "")}+${swift}`,
    `AM:${amount.toFixed(2)}`,
    "CC:EUR",
    `RN:${actorName.substring(0, 35)}`,
  ];
  return parts.join("*");
}

export const CzechQrCode = ({
  swift,
  actorName,
  iban,
  amount,
}: CzechQrCodeProps): React.ReactNode => {
  const { t } = useResource();

  const spaydString = buildSpaydString({ swift, actorName, iban, amount });

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: Spacing.S }}>
        {t(Resources.WithdrawalApprovals.CzechQrCode)}
      </Typography>
      <Box
        sx={(theme) => ({
          display: "inline-flex",
          p: Spacing.M,
          borderRadius: 2,
          // QR codes need a light quiet zone to stay scannable on the dark UI.
          backgroundColor: theme.palette.common.white,
        })}
      >
        <QRCodeSVG value={spaydString} size={200} level="M" />
      </Box>
    </Box>
  );
};
